import { Skeleton } from '@monksflow/monks-ui';

/**
 * Placeholder rows shown while the comments list is loading. Mirrors the
 * resting layout of a real comment row (avatar + name + two body lines) so
 * the swap doesn't shift the surrounding scroll container.
 */
export function CommentsPanelSkeleton() {
  return (
    <div
      data-testid="comments-panel-skeleton"
      aria-busy="true"
      aria-live="polite"
      className="flex flex-col gap-3 py-4"
    >
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index} className="flex flex-col rounded-lg p-2 pb-1">
          <div className="flex items-center gap-2">
            <Skeleton className="size-6 rounded-full" />
            <Skeleton className="h-3.5 w-24" />
          </div>
          {/* Body indented pl-8 to align under the name, past the avatar
              (size-6 + gap-2), mirroring the real comment leaf. */}
          <div className="flex flex-col gap-1 pb-2 pl-8 pr-2">
            <Skeleton className="h-3.5 w-full" />
            <Skeleton className="h-3.5 w-4/5" />
          </div>
        </div>
      ))}
    </div>
  );
}
